/* =================== SOLUÇÕES POLÍTICAS HOME =================== */
$(function () {
  $(".carrosel-solucoes-politicas").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: "unslick",
      },
    ],
  });
});
